export default __webpack_public_path__ + "app/images/0f8863c64decdc020ec1d1ebf1cf37eb.png";